import React, { Component } from 'react';
import Select from 'react-select';
import { MdSearch, MdRefresh } from 'react-icons/lib/md';
import { FaFileExcelO } from 'react-icons/lib/fa';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { DateField } from '../detail/schedule_utils';
import { DateFieldFixedDateBelow } from '../detail/date_picker_fixed_dateBelow';

import {fetch_lkp_JobType_AE, fetch_lkp_QueueType_AE, fetch_lkp_StatusTracking_AE, fetch_lkp_Discipline_AE,
fetch_lkp_Studio_AE, fetch_lkp_DesignSource_AE, fetch_lkp_Track_AE, fetch_lkp_Phase_AE, setCurrentTabIndex,
fetchAESearchResults_AE, fetchAllMembers_AE } from '../../actions/additional_actions';

import { withAuth } from '../../actions/';
import { fetchProjectsAESearch } from '../../actions/projects_actions';
import { getDateValue } from '../../utils/date';

class AeSearch extends Component {
    constructor(props) {
        super(props);

        this.handleSelectChangeAETracking = this.handleSelectChangeAETracking.bind(this);
        this.handleAESearchExcel = this.handleAESearchExcel.bind(this);
        this.handleAEReset = this.handleAEReset.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.handleLeaderMultiChange = this.handleLeaderMultiChange.bind(this);
        this.handleMemberMultiChange = this.handleMemberMultiChange.bind(this);
        this.state = {
            aeTracking: this.getInitialState(),
            aeSearchClicked: false,
            aeResetClicked: true,
            checked: {
                leaderActive : true,
                memberActive : true
            }
        };
    }

    getInitialState() {
        return {
            projectId: '',
            id: -1,
            benchmarkStatus: '',
            submittedDate: '',
            comment: '',
            projectBudget: '',
            countDown: '',
            teamLeader: '',
            jobTypeId: '',
            strategyBoardDate: '',
            disciplineId: '',
            designSourceId: '',
            trackId: '',
            phaseId: '',
            studioId: '',
            statusTrackingId: '',
            member_AE_Id: [],
            leader_AE_Id: [],
        }
    }

    UNSAFE_componentWillMount() {
        const { jobTypes_AE, queueTypes_AE, statusTracking_AE, studios_AE, disciplines_AE,
            designSources_AE, tracks_AE, phases_AE, allMembers_AE } = this.props;

        if (jobTypes_AE.length === 0) this.props.fetch_lkp_JobType_AE();
        if (queueTypes_AE.length === 0) this.props.fetch_lkp_QueueType_AE();
        if (statusTracking_AE.length === 0) this.props.fetch_lkp_StatusTracking_AE();
        if (studios_AE.length === 0) this.props.fetch_lkp_Studio_AE();
        if (disciplines_AE.length === 0) this.props.fetch_lkp_Discipline_AE();
        if (designSources_AE.length === 0) this.props.fetch_lkp_DesignSource_AE();
        if (tracks_AE.length === 0) this.props.fetch_lkp_Track_AE();
        if (phases_AE.length === 0) this.props.fetch_lkp_Phase_AE();

        if (allMembers_AE && allMembers_AE.length === 0) this.props.fetchAllMembers_AE();
    }

    getSelectOptions(values, name) {
        const { trackId } = this.state.aeTracking;

        let selectList = this.props[values].slice();

        if (values === 'phases_AE') {
            if (trackId !== null && trackId !== '' && trackId !== undefined)
                selectList = selectList.filter(phase => phase.trackingId === trackId);
            else {
                selectList = selectList.filter((thing, index, self) =>
                    index === self.findIndex((t) => (
                        t.phaseName === thing.phaseName
                    ))
                )
            }
        }

        return selectList.map(value => {
            if (value !== null && value[name] !== null) {
                return {
                    label: value[name],
                    value: value.id
                }
            }
            else return null;
        });
    }
    getSelectOptionsLeaders(values, name) {
        let leaderList =[];
        let List = this.props[values] && this.props[values].slice();   
        if(this.state.checked.leaderActive === undefined && this.state.checked.leaderInActive !== true){
            leaderList = List.filter(function (emp){
                return emp.isActive === true;

            })
        }  
        else if(this.state.checked.leaderActive === undefined && this.state.checked.leaderInActive === true){
            leaderList = List;
        }  
        else if(this.state.checked.leaderActive === true && this.state.checked.leaderInActive === true){
            leaderList = List;
        }
        else if(this.state.checked.leaderActive === true){
            leaderList = List.filter(function (emp){
                return emp.isActive === true;

            })
        }
        else  if(this.state.checked.leaderInActive === true){
            leaderList = List.filter(function (emp){
                return emp.isActive !== true;

            })
        }        
        else {
            leaderList = [];
        }

        return leaderList && leaderList.map(value => {
            return {
                label: value.employee['firstName'] + ' ' + value.employee['lastName'],
                value: value.id
            }
        });
    }
    getSelectOptionsMembers(values, name) {
        let selectList =[];
        let List = this.props[values] && this.props[values].slice();     
        if(this.state.checked.memberActive === undefined && this.state.checked.memberInActive !== true){
            selectList = List.filter(function (emp){
                return emp.isActive === true;

            })
        }  
        else if(this.state.checked.memberActive === undefined && this.state.checked.memberInActive === true){
            selectList = List;
        }     
        else if(this.state.checked.memberActive === true && this.state.checked.memberInActive === true){
            selectList = List;
        }
        else if(this.state.checked.memberActive === true){
            selectList = List.filter(function (emp){
                return emp.isActive === true;

            })
        }
        else  if(this.state.checked.memberInActive === true){
            selectList = List.filter(function (emp){
                return emp.isActive !== true;

            })
        }        
        else {
            selectList = [];
        }

        return selectList && selectList.map(value => {
            return {
                label: value.employee['firstName'] + ' ' + value.employee['lastName'],
                value: value.id
            }
        });
    }

    handleCheck(name) {        
        return (e) => {
            const checked = this.state.checked;
      
            if (checked[name] === true)
            checked[name] = false;
            else
            checked[name] = true;
      
            this.setState({ checked });
          }
    }
   
    getOptionsForStatus() {
        const values = ['Active', 'On-Hold' , 'Completed', 'Cancelled'];
        return values.map(value => {
          return { label: value, value }
        });
      }

    handleSelectChangeAETracking(field) {
        return (option) => {
            let value = option ? option.value : null;
            let aeTracking = { ...this.state.aeTracking, [field]: value }
            this.setState({ aeTracking });
        }
    }

    handleLeaderMultiChange(option) {
        let aeTracking = { ...this.state.aeTracking, leader_AE_Id: option };   
        this.setState({ aeTracking });         
    }
    
    handleMemberMultiChange(option) {
        let aeTracking = { ...this.state.aeTracking, member_AE_Id: option };   
        this.setState({ aeTracking });            
    }

    handleDateChange(name) {
        return (date) => {
            let aeTracking = { ...this.state.aeTracking, [name]: date }
            this.setState({ aeTracking });
        }
    }

    handleAESearch(currentPage) {
        const { aeTracking } = this.state;

        let { aeTargetDateFrom, aeTargetDateTo, pmExpectedSubmissionDateFrom, pmExpectedSubmissionDateTo, queueTypeId, leader_AE_Id, member_AE_Id, phaseId,
            projectId, jobTypeId, disciplineId, designSourceId, trackId, studioId, benchmarkStatus, statusTrackingId } = aeTracking;
        return (e) => {
            e.preventDefault();
            var criteria = {
                projectid: projectId || null,
                benchmarkStatus: benchmarkStatus || null,
                pmExpectedSubmissionDateFrom: pmExpectedSubmissionDateFrom || null,
                pmExpectedSubmissionDateTo: pmExpectedSubmissionDateTo || null,
                aeTargetDateFrom: aeTargetDateFrom || null,
                aeTargetDateTo: aeTargetDateTo || null,
                jobTypeId: jobTypeId || null,
                queueTypeId: queueTypeId || null,
                teamLeaderId: leader_AE_Id || null,
                teamMemberId: member_AE_Id || null,
                disciplineId: disciplineId || null,
                designSourceId: designSourceId || null,
                trackId: trackId || null,
                currentPhaseId: phaseId || null,
                studioId: studioId || null,
                statusTrackingId: statusTrackingId || null,
            };

            clearTimeout(this.timerId);
            this.timerId = setTimeout(() => {
                const params = { data: criteria, currentPage, skip: currentPage * 10 };
                this.props.fetchAESearchResults_AE(params);
            }, 300);

            this.setState({ aeSearchClicked: true, aeResetClicked: false });
        }
    }

    handleAESearchExcel() {
        var criteria = {
            'ProjectId': this.state.aeTracking.projectId,
            'BenchmarkStatus': this.state.aeTracking.benchmarkStatus,
            'PmExpectedSubmissionDateFrom': this.state.aeTracking.pmExpectedSubmissionDateFrom,
            'PmExpectedSubmissionDateTo': this.state.aeTracking.pmExpectedSubmissionDateTo,
            'AeTargetDateFrom': this.state.aeTracking.aeTargetDateFrom,
            'AeTargetDateTo': this.state.aeTracking.aeTargetDateTo,
            'JobTypeId': this.state.aeTracking.jobTypeId,
            'QueueTypeId': this.state.aeTracking.queueTypeId,
            'TeamLeaderId': this.state.aeTracking.leader_AE_Id,
            'TeamMemberId': this.state.aeTracking.member_AE_Id,
            'DisciplineId': this.state.aeTracking.disciplineId,
            'DesignSourceId': this.state.aeTracking.designSourceId,
            'TrackId': this.state.aeTracking.trackId,
            'CurrentPhaseId': this.state.aeTracking.phaseId,
            'StudioId': this.state.aeTracking.studioId,
            'StatusTrackingId': this.state.aeTracking.statusTrackingId
        };

        let url = 'projects/AESearchResultsExcel';
        let method = 'post';
        let responseType = 'arraybuffer';
        withAuth(
            { method, url, responseType, data: criteria },
            (response) => {
                var data = response.data;
                var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                var blob = new Blob([data], { type: contentType });
                var downloadUrl = window.URL.createObjectURL(blob);
                var link = document.createElement('a');
                link.href = downloadUrl;
                link.download = 'Project Search Result.xlsx';
                link.click();
            },
            this.errorHandler
        )
    }

    handleAEReset() {
        this.setState({ aeTracking: '', aeSearchClicked: false, aeResetClicked: true,  checked: {},        
      });   
        
    }

    handleChangeProjectIdAE() {
        return (e) => {
            const aeTracking = { ...this.state.aeTracking, projectId: e.target.value }
            this.setState({ aeTracking });
        }
    }

    redirectToProjectAESearch(projectId) {
        this.props.setCurrentTabIndex(7);
        this.setState({redirect: true, projectIdAEGrid: projectId});
      }

    renderPaginationAESearch() {
        const { currentPage_AE, searchResults_AE, count_AE } = this.props;
        const { aeResetClicked } = this.state;

        if (searchResults_AE.length === 0)
            return null;

        const rem = count_AE % 10;
        const divCount = Math.floor(count_AE / 10);
        const pageCount = (rem === 0) ? divCount - 1 : divCount;

        return (
            <div className="container">
                <div className="row">
                    <div className="col s12">
                        <ul className="pagination">
                            <li className="prev">{currentPage_AE > 0 && !aeResetClicked && <a href="# " onClick={this.handleAESearch(currentPage_AE - 1)}>← Previous</a>}</li>
                            <li className="next">{currentPage_AE < pageCount && !aeResetClicked && <a href="# " onClick={this.handleAESearch(currentPage_AE + 1)}>Next →</a>}</li>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const { checked} = this.state;     
        const { aeTracking, aeSearchClicked, redirect, projectIdAEGrid } = this.state;
        const { searchResults_AE, count_AE } = this.props;
        let aeSearchRecKey = 0;

        if (redirect) {
            const path = `/projects/${projectIdAEGrid}`;
            return <Redirect push={true} to={path} />;
          }

        return (
            <div>
                <div className="container">
                    <div className="row">
                        <div className="col s12">
                            <button type="button">
                                <h4 className="advance-search">A&E SEARCH</h4>
                            </button>
                        </div>
                    </div>

                    <form onSubmit={this.handleAESearch(0)}>
                        <div>
                            <div className="row margin-top-1">

                                <div className="col l2 m3 s6">
                                    <label className="label-select-search">Project ID</label>
                                    <div className="search-box search-box-small margin-bottom-0">
                                         <input type="text" autoFocus
                                            className="search-input"
                                            value={aeTracking && aeTracking.projectId} onChange={this.handleChangeProjectIdAE()}
                                        /> 
                                    </div>
                                </div>

                                <div className="col l2 m3 s6">
                                    <div className="controls with-select">
                                        <label className="label-select-search">Job Type</label>
                                        <Select name='jobType_AE'
                                            value={aeTracking && aeTracking.jobTypeId}
                                            options={this.getSelectOptions('jobTypes_AE', 'jobType')}
                                            onChange={this.handleSelectChangeAETracking('jobTypeId')} />
                                    </div>
                                </div>

                                <div className="col l1 m3 s6">
                                    <div className="controls with-select">
                                        <label className="label-select-search">Queue Type</label>
                                        <Select name='qType'
                                            value={aeTracking && aeTracking.queueTypeId}
                                            options={this.getSelectOptions('queueTypes_AE', 'qType')}
                                            onChange={this.handleSelectChangeAETracking('queueTypeId')} />
                                    </div>
                                </div>

                                 <div className="col l1 m3 s6">
                                    <div className="controls with-select">
                                        <label className="label-select-search">Project Status</label>
                                        <Select name='benchmarkStatus'
                                            value={aeTracking && aeTracking.benchmarkStatus}
                                            options={this.getOptionsForStatus()}
                                            onChange={this.handleSelectChangeAETracking('benchmarkStatus')} />
                                    </div>
                                </div> 

                                <div className="col l2 m3 s6">
                                    <div className="controls with-select">
                                        <label className="label-select-search">Team Leader</label>
                                        <Select name='allMembers_AE'
                                            value={aeTracking && aeTracking.leader_AE_Id}
                                            options={this.getSelectOptionsLeaders('allMembers_AE', 'leader_AE_Id')}
                                            onChange={this.handleLeaderMultiChange} multi />
                                    </div>
                                    <div>
                                        <div className="col m6 s6">
                                            <input id="leaderActive"
                                                type="checkbox"
                                                onChange={this.handleCheck('leaderActive')}
                                                checked={this.state.checked.leaderActive}
                                                defaultChecked={true}
                                            />
                                            <label className="tlactive">Active</label><span></span>
                                        </div>
                                        <div className="col m6 s6">
                                            <input id="leaderInActive"
                                                type="checkbox"
                                                onChange={this.handleCheck('leaderInActive')}
                                                checked={this.state.checked.leaderInActive}
                                                defaultChecked={false}
                                            />
                                            <label className="tlinactive">Inactive</label><span></span>
                                        </div>
                                    </div>
                                </div>

                                <div className="col l2 m3 s6">
                                    <div className="controls with-select">
                                        <label className="label-select-search">Team Member</label>
                                        <Select name='allMembers_AE'
                                            value={aeTracking && aeTracking.member_AE_Id}
                                            options={this.getSelectOptionsMembers('allMembers_AE', 'member_AE_Id')}
                                            onChange={this.handleMemberMultiChange} multi />
                                            
                                    </div>
                                    <div>
                                        <div className="col m6 s6">
                                            <input id="memberActive"
                                                type="checkbox"
                                                onChange={this.handleCheck('memberActive')}
                                                checked={checked.memberActive}
                                                defaultChecked={true}                                     
                                            />
                                            <label className="tmactive">Active</label><span></span>
                                        </div>
                                        <div className="col m6 s6">
                                            <input id="memberInActive"
                                                type="checkbox"
                                                onChange={this.handleCheck('memberInActive')}
                                                checked={checked.memberInActive}
                                                defaultChecked={false} 
                                            />
                                            <label className="tminactive">Inactive</label><span></span>
                                        </div>
                                    </div>
                                </div>

                                <div className="col l2 m3 s6">
                                    <div className="controls with-select">
                                        <label className="label-select-search">Studio - Team Leader</label>
                                        <Select name='studio'
                                            value={aeTracking && aeTracking.studioId}
                                            options={this.getSelectOptions('studios_AE', 'studio')}
                                            onChange={this.handleSelectChangeAETracking('studioId')} />
                                    </div>
                                </div>

                            </div>

                            <div className="row margin-top-1">

                                <div className="col l2 m2 s6">
                                    <div className="controls with-select">
                                        <label className="label-select-search">Discipline</label>
                                        <Select name='discipline'
                                            value={aeTracking && aeTracking.disciplineId}
                                            options={this.getSelectOptions('disciplines_AE', 'discipline')}
                                            onChange={this.handleSelectChangeAETracking('disciplineId')} />
                                    </div>
                                </div>

                                <div className="col l2 m2 s6">
                                    <div className="controls with-select">
                                        <label className="label-select-search">Design Source</label>
                                        <Select name='designSource'
                                            value={aeTracking && aeTracking.designSourceId}
                                            options={this.getSelectOptions('designSources_AE', 'designSource')}
                                            onChange={this.handleSelectChangeAETracking('designSourceId')} />
                                    </div>
                                </div>

                                <div className="col l2 m2 s6">
                                    <div className="controls with-select">
                                        <label className="label-select-search">Track</label>
                                        <Select name='track'
                                            value={aeTracking && aeTracking.trackId}
                                            options={this.getSelectOptions('tracks_AE', 'track')}
                                            onChange={this.handleSelectChangeAETracking('trackId')} />
                                    </div>
                                </div>

                                <div className="col l2 m3 s6">
                                    <div className="controls with-select">
                                        <label className="label-select-search">A&E Current Phase</label>
                                        <Select name='phase'
                                            value={aeTracking && aeTracking.phaseId}
                                            options={this.getSelectOptions('phases_AE', 'phaseName')}
                                            onChange={this.handleSelectChangeAETracking('phaseId')} />
                                    </div>
                                </div>

                                <div className="col l2 m3 s6">
                                    <label className="label-select-search">Request Status</label>
                                    <Select name='requestStatus'
                                        value={aeTracking && aeTracking.statusTrackingId}
                                        options={this.getSelectOptions('statusTracking_AE', 'status')}
                                        onChange={this.handleSelectChangeAETracking('statusTrackingId')} />
                                </div>

                            </div>

                            <div className="row">

                                <div className="col l5">
                                    <fieldset className="margin-top-1">
                                        <legend className="text-center">PM Expected Submission Date </legend>

                                        <div className="row margin-top-075">
                                            <div className="col l10 borger-grey-ae">

                                                <div className="col l7 m6 s12">
                                                    <label className="label-select-search">From</label>
                                                    <div className="date-input-custom-search">
                                                        <DateFieldFixedDateBelow limits={{ dateBelow: aeTracking.pmExpectedSubmissionDateTo }}
                                                            value={aeTracking && aeTracking.pmExpectedSubmissionDateFrom}
                                                            onChange={this.handleDateChange('pmExpectedSubmissionDateFrom')}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col l5 m6 s12">
                                                    <label className="label-select-search">To</label>
                                                    <div className="date-input-custom-search">
                                                        <DateField limits={{ dateAbove: aeTracking.pmExpectedSubmissionDateFrom }}
                                                            value={aeTracking && aeTracking.pmExpectedSubmissionDateTo}
                                                            onChange={this.handleDateChange('pmExpectedSubmissionDateTo')}
                                                        />
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </fieldset>
                                </div>

                                <div className="col l5 offset-l1">
                                    <fieldset className="margin-top-1">
                                        <legend className="text-center">A&E Target Date</legend>

                                        <div className="row margin-top-075">
                                            <div className="col l10 borger-grey-ae">
                                                <div className="col l7 m6 s12">
                                                    <label className="label-select-search">From</label>
                                                    <div className="date-input-custom-search">
                                                        <DateFieldFixedDateBelow limits={{ dateBelow: aeTracking.aeTargetDateTo }}
                                                            value={aeTracking && aeTracking.aeTargetDateFrom}
                                                            onChange={this.handleDateChange('aeTargetDateFrom')}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col l5 m6 s12">
                                                    <label className="label-select-search">To</label>
                                                    <div className="date-input-custom-search">
                                                        <DateField limits={{ dateAbove: aeTracking.aeTargetDateFrom }}
                                                            value={aeTracking && aeTracking.aeTargetDateTo}
                                                            onChange={this.handleDateChange('aeTargetDateTo')}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>

                            </div>


                            <div className="row search-btns">
                                <button className="btn-save" type="submit">
                                    <span className="margin-right-05">
                                        <MdSearch size={18} color='#1180BA' />
                                    </span>
                                    Search
                                 </button>

                                <button className="btn-save btn-reset" type="reset" color='#3A4454'
                                    onClick={this.handleAEReset}>
                                    <span className="margin-right-05">
                                        <MdRefresh size={18} color='#3A4454' />
                                    </span>
                                    Reset
                                </button>
                            </div>
                        </div>
                    </form>
                </div>

                <br />

                <div className="row-wide">
                    {(aeSearchClicked && searchResults_AE.length > 0) &&
                        <div className="row" id="advanceSearchExcelCont">
                            <div className="col s2">
                                <p>Results: {count_AE}</p>
                            </div>
                            <div className="col s10">
                                <button className="btn-save btn-excel float-right" type="button" onClick={this.handleAESearchExcel}>
                                    <span className="margin-right-05"> <FaFileExcelO size={18} color='#008000' /></span>
                                    Excel</button>
                            </div>
                        </div>}

                    {aeSearchClicked &&
                        <div className="col s12">
                            <div className="table-wrap advance-search-table">
                                <table className="table-striped">
                                    {searchResults_AE.length > 0 &&
                                        <thead>
                                            <tr>
                                                <th>Project ID</th>
                                                <th>Project Description</th>
                                                <th>Projects Status</th>
                                                <th>Program Unit</th>
                                                <th>Project Manager</th>
                                                <th>Job Type</th>
                                                <th>Current A&E Phase</th>
                                                <th>Queue Type</th>
                                                <th>PM Expected Submission Date</th>
                                                <th>A&E Target Date</th>
                                                <th>Team Leader</th>
                                                <th>Team member</th>
                                                <th>Studio</th>
                                                <th>Design Source</th>
                                                <th>Discipline</th>
                                            </tr>
                                        </thead>
                                    }
                                    <tbody>
                                        {searchResults_AE.map(aeRec =>
                                            <tr
                                                key={aeSearchRecKey++}
                                                onClick={() => this.redirectToProjectAESearch(aeRec.projectid)}>
                                                <td>{aeRec.projectid}</td>
                                                <td>{aeRec.projectDescription}</td>
                                                <td>{aeRec.benchmarkStatus}</td>
                                                <td>{aeRec.unitName}</td>
                                                <td>{aeRec.dpm}</td>
                                                <td>{aeRec.jobType}</td>
                                                <td>{aeRec.currentPhaseName}</td>
                                                <td>{aeRec.qType}</td>
                                                <td>{getDateValue(aeRec.pmExpectedSubmissionDate)}</td>
                                                <td>{getDateValue(aeRec.aeTargetDate)}</td>
                                                <td>{aeRec.teamLeader}</td>
                                                <td>{aeRec.teamMember}</td>
                                                <td>{aeRec.studio}</td>
                                                <td>{aeRec.designSource}</td>
                                                <td>{aeRec.discipline}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                {aeSearchClicked && searchResults_AE.length === 0 &&
                                    <div className="container projects-empty">
                                        <div className="row">
                                            <div className="col s12">
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>

                {this.renderPaginationAESearch()}
                {this.props.errorMessage ? <div className="pagination error-text">{this.props.errorMessage}</div> : null}

            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        jobTypes_AE: state.additionalProjectsStore.jobTypes_AE,
        queueTypes_AE: state.additionalProjectsStore.queueTypes_AE,
        statusTracking_AE: state.additionalProjectsStore.statusTracking_AE,
        studios_AE: state.additionalProjectsStore.studios_AE,
        disciplines_AE: state.additionalProjectsStore.disciplines_AE,
        designSources_AE: state.additionalProjectsStore.designSources_AE,
        tracks_AE: state.additionalProjectsStore.tracks_AE,
        phases_AE: state.additionalProjectsStore.phases_AE,
        allMembers_AE: state.additionalProjectsStore.allMembers_AE,
        searchResults_AE: state.additionalProjectsStore.searchResults_AE,
        currentPage: state.projectsStore.currentPage,
        currentPage_AE: state.additionalProjectsStore.currentPage_AE,
        count_AE: state.additionalProjectsStore.count_AE,
        errorMessage: state.additionalProjectsStore.errorMessage ? state.additionalProjectsStore.errorMessage : null,
    }
}

export default connect(mapStateToProps, {
    fetchProjectsAESearch,
    fetchAESearchResults_AE,
    fetch_lkp_JobType_AE,
    fetch_lkp_QueueType_AE,
    fetch_lkp_StatusTracking_AE,
    fetch_lkp_Studio_AE,
    fetch_lkp_Discipline_AE,
    fetch_lkp_DesignSource_AE,
    fetch_lkp_Track_AE,
    fetch_lkp_Phase_AE,
    fetchAllMembers_AE,
    setCurrentTabIndex,
})(AeSearch);